<h1 mat-dialog-title class="p-2 text-center">Nouvelle mesure</h1>
<div class="p-3">
    <div class="col">
        <div class="row overflow-auto">
            <mat-form-field class="col-6">
                <mat-label>Distance Rive 0</mat-label>
                <input matInput placeholder="Distance Rive 0" type="number" [(ngModel)]="mesureList[0].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm)</mat-label>
                <input matInput placeholder="Profondeur (cm) 0" type="number" [(ngModel)]="mesureList[0].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">                [formControl]="ValidProfondeur (cm)Max"
                    Max {{DMAX}}m 
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 1</mat-label>
                <input matInput placeholder="Distance Rive 1" type="number" [(ngModel)]="mesureList[1].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 1</mat-label>
                <input matInput placeholder="Profondeur (cm) 1" type="number" [(ngModel)]="mesureList[1].Profondeur">
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 2</mat-label>
                <input matInput placeholder="Distance Rive 2" type="number" [(ngModel)]="mesureList[2].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 2</mat-label>
                <input matInput placeholder="Profondeur (cm) 2" type="number" [(ngModel)]="mesureList[2].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 3</mat-label>
                <input matInput placeholder="Distance Rive 3" type="number" [(ngModel)]="mesureList[3].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 3</mat-label>
                <input matInput placeholder="Profondeur (cm) 3" type="number" [(ngModel)]="mesureList[3].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 4</mat-label>
                <input matInput placeholder="Distance Rive 4" type="number" [(ngModel)]="mesureList[4].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 4</mat-label>
                <input matInput placeholder="Profondeur (cm) 4" type="number" [(ngModel)]="mesureList[4].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 5</mat-label>
                <input matInput placeholder="Distance Rive 5" type="number" [(ngModel)]="mesureList[5].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 5</mat-label>
                <input matInput placeholder="Profondeur (cm) 5" type="number" [(ngModel)]="mesureList[5].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 6</mat-label>
                <input matInput placeholder="Distance Rive 6" type="number" [(ngModel)]="mesureList[6].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 6</mat-label>
                <input matInput placeholder="Profondeur (cm) 6" type="number" [(ngModel)]="mesureList[6].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 7</mat-label>
                <input matInput placeholder="Distance Rive 7" type="number" [(ngModel)]="mesureList[7].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 7</mat-label>
                <input matInput placeholder="Profondeur (cm) 7" type="number" [(ngModel)]="mesureList[7].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 8</mat-label>
                <input matInput placeholder="Distance Rive 8" type="number" [(ngModel)]="mesureList[8].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 8</mat-label>
                <input matInput placeholder="Profondeur (cm) 8" type="number" [(ngModel)]="mesureList[8].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 9</mat-label>
                <input matInput placeholder="Distance Rive 9" type="number" [(ngModel)]="mesureList[9].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 9</mat-label>
                <input matInput placeholder="Profondeur (cm) 9" type="number" [(ngModel)]="mesureList[9].Profondeur">
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 10</mat-label>
                <input matInput placeholder="Distance Rive 10" type="number" [(ngModel)]="mesureList[10].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 10</mat-label>
                <input matInput placeholder="Profondeur (cm) 10" type="number" [(ngModel)]="mesureList[10].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 11</mat-label>
                <input matInput placeholder="Distance Rive 11" type="number" [(ngModel)]="mesureList[11].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 11</mat-label>
                <input matInput placeholder="Profondeur (cm) 11" type="number" [(ngModel)]="mesureList[11].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 12</mat-label>
                <input matInput placeholder="Distance Rive 12" type="number" [(ngModel)]="mesureList[12].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 12</mat-label>
                <input matInput placeholder="Profondeur (cm) 12" type="number" [(ngModel)]="mesureList[12].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 13</mat-label>
                <input matInput placeholder="Distance Rive 13" type="number" [(ngModel)]="mesureList[13].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 13</mat-label>
                <input matInput placeholder="Profondeur (cm) 13" type="number" [(ngModel)]="mesureList[13].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 14</mat-label>
                <input matInput placeholder="Distance Rive 14" type="number" [(ngModel)]="mesureList[14].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 14</mat-label>
                <input matInput placeholder="Profondeur (cm) 14" type="number" [(ngModel)]="mesureList[14].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label>Distance Rive 15</mat-label>
                <input matInput placeholder="Distance Rive 15" type="number" [(ngModel)]="mesureList[15].DistanceRive">
                <!-- <mat-error *ngIf="ValidDistanceRiveMax.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label>Profondeur (cm) 15</mat-label>
                <input matInput placeholder="Profondeur (cm) 15" type="number" [(ngModel)]="mesureList[15].Profondeur" >
                <!-- <mat-error *ngIf="ValidProfondeur (cm)Max.hasError('max')">
                    Max {{DMAX}}m
                </mat-error> -->
            </mat-form-field>

        </div>
        <div class="row">
            <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                Annuler<mat-icon>undo</mat-icon>
            </button>
        </div>
        <div class="row">
            <button class="col mx-3 my-1" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
                Sauvegarder<mat-icon>save</mat-icon>
            </button>
        </div>
    </div>
</div>